import { observer } from 'mobx-react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyData from 'app/components/EmptyData';
import ErrorBox from 'app/components/ErrorBox';
import useCustomerInfo from 'app/hooks/useCustomerInfo';
import Button from 'components/base/Button';
import Skeleton from 'components/base/Skeleton';
import ResultPage from 'components/ResultPage';
import useGotoProfile from 'hooks/useGotoProfile';
import { CategoryEnum } from 'types/customer';
import { useTrack } from 'utils/track';
import withProgressForm from 'utils/withProgressForm';

const Complete: FC = () => {
    const { isLoading, error, data, mutate } = useCustomerInfo();
    const { trackEvent } = useTrack();
    const navigate = useNavigate();
    const { category } = data || {};
    const isIRA = category === CategoryEnum.IRA;
    const goToProfile = useGotoProfile();
    const handleClick = () => {
        trackEvent({
            model: '开户-审核中',
            name: '审核中-点击好的'
        });

        if (isIRA) {
            goToProfile();
        } else {
            navigate('/profile/deposit', { replace: true });
        }
    };

    if (isLoading) {
        return <Skeleton line={5} />;
    }

    if (error) {
        return <ErrorBox error={error} onClick={() => mutate()} />;
    }

    if (!data) {
        return <EmptyData />;
    }

    /**
     * IRA: 不展示去入金按钮, 点击按钮回个人中心
     * 非IRA: 展示去入金按钮, 点击按钮去入金
     */
    return (
        <div>
            <ResultPage
                className="mb-3"
                status="SUCCESS"
                contentOptions={{
                    text: __('Congratulations!')
                }}
                descriptionOptions={{
                    text: __(
                        'Your application has been submitted successfully. You will receive a confirmation email once your account is approved.'
                    )
                }}
                btnOptions={{
                    text: isIRA ? __('DONE') : __('Fund My Account')
                }}
                onClick={handleClick}
            />
            {!isIRA && (
                <Button
                    block
                    type="dark"
                    ghost
                    size="lg"
                    onClick={() => navigate('/profile?type=open', { replace: true })}>
                    {__('Go to My account')}
                </Button>
            )}
        </div>
    );
};

export default withProgressForm({
    cache: false,
    basePath: 'open',
    showProgressBar: false,
    eventParams: {
        exposureEventParams: {
            model: '开户-审核中',
            name: '审核中-页面曝光'
        }
    }
})(observer(Complete));
